import { StarIcon } from '@icons';
import { setupForDark } from '@theme';
import classNames from 'classnames';

const ratingToArray = (float) => {
  let arr = [];
  let whole = Math.floor(float);
  let reminder = float - whole;
  while (whole > 0) {
    arr.push(1);
    whole--;
  }
  arr.push(reminder);

  if (arr.length < 5) {
    while (arr.length < 5) {
      arr.push(0);
    }
  }
  if (arr.length > 5) {
    arr = arr.slice(0, 5);
  }

  return arr;
};

const roundToQuarter = (float) => {
  return Math.round(float * 4) / 4;
};

const valueToIcon = (key, value, size) => {
  const quarterValue = roundToQuarter(value);
  switch (quarterValue) {
    case 0:
      return <StarIcon key={key} size={size} fillLevel='0' />;
    case 0.25:
      return <StarIcon key={key} size={size} fillLevel='1' />;
    case 0.5:
      return <StarIcon key={key} size={size} fillLevel='2' />;
    case 0.75:
      return <StarIcon key={key} size={size} fillLevel='3' />;
    case 1:
      return <StarIcon key={key} size={size} fillLevel='4' />;
    default:
      break;
  }
};

function Rating({ rating, size = 16 }: { rating: number; size?: number }) {
  if (!rating) {
    return <></>;
  }

  return (
    <div className='flex flex-row gap-xs items-center'>
      <div className={classNames('P3B', 'text-secondary')}>{rating.toFixed(1)}</div>
      <div
        className={classNames(
          'flex flex-row gap-xxs items-center',
          setupForDark('text-icon-quaternary')
        )}
      >
        {ratingToArray(rating).map((value, index) => valueToIcon(index, value, size))}
      </div>
    </div>
  );
}

export default Rating;
